module.exports = __webpack_public_path__ + "static/media/intentional-living.461c18c6.png";